import { useRef } from 'react';

export const useDebounce = (callback: any, delay: number) => {
  const timeoutRef: any = useRef(null);

  return (...args: any) => {
    clearTimeout(timeoutRef.current);

    timeoutRef.current = setTimeout(() => {
      timeoutRef.current = null;
      callback(...args);
    }, delay);
  };
};
